import $ from 'jquery'

export function init() {
  $(document).on('click', '[data-header-action-toggle]', function (event) {
    hideAllMenus()
    $(event.currentTarget).parent().toggleClass('active')
    event.preventDefault()
  })

  $(document).on('click', function (event) {
    hideAllMenus()
  })

  $('[data-mobile-search-button]').on('click', function (event) {
    $('[data-mobile-search-bar]').addClass('open')
    $('[data-mobile-search-bar] input[type="search"]').trigger('focus')
  })
  $('[data-mobile-search-bar] [data-underlay]').on('click', function (event) {
    $('[data-mobile-search-bar]').removeClass('open')
  })
}

function hideAllMenus() {
  const $active = $('.header-actions li.active')
  if ($active.length && !$.contains($active.get(0), event.target)) {
    $active.removeClass('active')
  }
}
